export const GET_PRODUCTS = 'GET_PRODUCTS'
export const SHOW_PRODUCTS = 'SHOW_PRODUCTS'
export const SHOW_PRODUCT = 'SHOW_PRODUCT'
export const SHOW_MORE_PRODUCTS = 'SHOW_MORE_PRODUCTS'

export const GET_CATEGORIES = 'GET_CATEGORIES'
export const SHOW_CATEGORIES = 'SHOW_CATEGORIES'


export const GET_ERROR = 'GET_ERROR'
export const GET_SUCCESS = 'GET_SUCCESS'